import { TableColumnConfig } from '@shared/model';

export const servicingFacilityColsConfig: TableColumnConfig[] = [
  { field: '', header: 'Parent Company Name', styles: { width: '12%' } },
  { field: '', header: 'NPI', styles: { width: '11%' } },
  { field: '', header: 'HP Network', styles: { width: '11%' } },
  { field: '', header: `Out of Member's Network`, styles: { width: '11%' } },
  { field: '', header: `Gold Card Provider`, styles: { width: '11%' } },
  { field: '', header: `Gold Card Auth Type`, styles: { width: '11%' } },
  { field: '', header: 'Tax ID', styles: { width: '11%' } },
  { field: '', header: 'CMS Number', styles: { width: '11%' } },
  { field: '', header: 'Medicaid Number', styles: { width: '11%' } },
];
